import { styled } from "@mui/material/styles";
import { TextField } from "../text-field/text-field.js";
import "react/jsx-runtime";
import "react";
import "@mui/material/TextField/index.js";
import "../text-field/text-field.styles.js";
const StyledTextField = styled(TextField)`
  && {
    font-family: 'Lato';
    font-size: 16px;
    line-height: 22px;
    letter-spacing: 0.5px;

    .MuiInputBase-root {
      font-family: inherit;
      font-size: inherit;
      line-height: inherit;
      letter-spacing: inherit;
    }

    .MuiInputLabel-root {
      font-family: inherit;
      font-size: inherit;
      line-height: inherit;
      letter-spacing: inherit;
    }

    .MuiFormHelperText-root {
      font-family: inherit;
      font-size: 12px;
      line-height: 16px;
      letter-spacing: 0.4px;
    }
  }
`;
export {
  StyledTextField
};
